var render = function render(_c,_vm){return _c('router-link',{staticClass:"nav-item px-3 py-3 border-right border-light w-25",class:{ 'disabled' : _vm.props.disabled },attrs:{"to":_vm.props.to,"active-class":"active","event":_vm.props.disabled ? '': 'click'}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }